import { render, staticRenderFns } from "./WrittenComments.vue?vue&type=template&id=f5eff62e&scoped=true&"
import script from "./WrittenComments.vue?vue&type=script&lang=js&"
export * from "./WrittenComments.vue?vue&type=script&lang=js&"
import style0 from "./WrittenComments.vue?vue&type=style&index=0&id=f5eff62e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5eff62e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
